<template>
  <div class="message-box-bg flex-center" v-if="showMessageBox">
    <div class="message-box">
      <div class="message-box-main">
        <div class="message-box-top">
          <h5 class="flex-center">
            {{
              $t(
                "home.walletConnect.acceptInvitationMessageBox.connectYourAddress"
              )
            }}
          </h5>
          <i class="icon icon-close" @click="onShowMessageBox"></i>
        </div>
        <div class="message-box-content">
          <p>
            {{
              $t("home.walletConnect.acceptInvitationMessageBox.youShouldText")
            }}
          </p>
          <p class="text-max text-invite-address">{{ inviteAddress }}</p>
          <p>
            {{ $t("home.walletConnect.acceptInvitationMessageBox.followText") }}
          </p>
        </div>
        <div class="stpe-block flex-center">
          <div class="stpe-box flex-center">
            <i class="icon icon-authorization-gas-fee"></i>
            <h6 class="text-max">
              {{
                $t(
                  "home.walletConnect.acceptInvitationMessageBox.authorization"
                )
              }}
            </h6>
          </div>
          <div class="stpe-box flex-center">
            <i class="icon icon-authenticate-yourself"></i>
            <h6 class="text-max">
              {{
                $t("home.walletConnect.acceptInvitationMessageBox.verification")
              }}
            </h6>
          </div>
        </div>
        <ButtonCommon
          type="marginXBridge"
          class="flex-center box-but"
          width="280px"
          @click="toConfirm"
        >
          <strong class="text-max">{{
            $t("home.walletConnect.acceptInvitationMessageBox.confirm")
          }}</strong>
        </ButtonCommon>
      </div>
      <div class="message-box-bott">
        <p class="message-box-bott-addr">
          <a
            class="a-link"
            target="_blank"
            rel="noopener noreferrer"
            :href="aLink"
            >{{ aLink }}</a
          >
        </p>
        <p class="text-min text-opacity">
          {{ $t("home.walletConnect.acceptInvitationMessageBox.referText") }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonCommon from "@/components/Common/button";
export default {
  name: "MessageBox",
  components: {
    ButtonCommon,
  },
  props: {
    showMessageBox: Boolean,
    inviteAddress: {
      type: String,
      default: "",
    },
  },
  computed: {
    aLink() {
      return process.env.VUE_APP_INVITE;
    },
  },
  methods: {
    onShowMessageBox() {
      this.$emit("update:showMessageBox", !this.showMessageBox);
    },

    toConfirm() {
      this.$emit("confirm");
    },
  },
  mounted() {
    // window.localStorage.removeItem("walletconnect");
  },
};
</script>
<style lang="scss" scoped>
.message-box-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: colorRgba(#000, 0.68);
  flex-direction: column;
  .message-box-main {
    padding: 24px;
    background: #1e1f23;
    border-radius: 20px;
  }
  .message-box-bott {
    padding: 24px 40px;
    box-sizing: border-box;
    border-radius: 20px;

    .text-min {
      text-align: center;
      width: 320px;
      line-height: 20px;
      margin: 0 auto;
    }

    .message-box-bott-addr {
      margin-bottom: 10px;
      text-align: center;
      .a-link {
        text-align: center;
        font-size: 14px;
        background-image: linear-gradient(90deg, #18eed8 0%, #a6f616 100%);
        -webkit-background-clip: text;
        color: transparent;
      }

      span {
        &:first-child {
          color: #a6f616;
          margin-right: 12px;
        }
      }
    }
  }
  .message-box {
    width: 480px;
    background: #101314;
    border-radius: 24px;
    z-index: 9999;
    .message-box-top {
      position: relative;
      margin-bottom: 32px;
      .icon-close {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .stpe-block {
      margin-bottom: 48px;
      margin-top: 48px;
      .stpe-box {
        width: 200px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        height: 132px;
        flex-direction: column;

        &:first-child {
          margin-right: 16px;
        }

        h6 {
          text-align: center;
          max-width: 130px;
          margin-top: 16px;
          line-height: 18px;
        }
      }
    }
    .but-refresh {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        strong {
          text-decoration: underline;
        }
      }
    }
    .box-but {
      margin-bottom: 24px;
    }
    .message-box-content {
      text-align: center;

      p {
        line-height: 21px;

        &.text-invite-address {
          color: #a6f616;
        }
      }

      .qr-img {
        margin: 0 auto;
        box-sizing: border-box;
        width: 200px;
        height: 200px;
        padding: 8px;
        background: $lighten-color;
        border-radius: 8px;
        img {
          width: 100%;
        }
      }

      .describe {
        display: block;
        opacity: 0.5;
        padding: 22px 0 34px;
      }
    }
  }
}
</style>
